import isUndefined from 'lodash/isUndefined';
import merge from 'lodash/merge';
import { CRICKET_SLUG, SNOOKER_SLUG, DARTS_SLUG, BASEBALL_SLUG } from './constants';

/**
 * Takes an array of markets and merges the markets that have the same id.
 * @param {Array} markets array of markets to be merged.
 * @returns {Array} merged array of markets.
 */
export const mergeMarkets = (markets) => {
    const mergedMarkets = markets.reduce((acc, market) => {
        const { id: marketId } = market;

        return {
            ...acc,
            [marketId]: merge(acc[marketId], market),
        };
    }, {});

    return Object.values(mergedMarkets);
};

export const getMarketBetable = (market) => {
    const {
        betable: marketBetable,
        suspended: marketSuspended,
        tradable: marketTradable,
        active: marketActive,
    } = market;

    if (!isUndefined(marketBetable)) {
        return marketBetable;
    }
    if (!isUndefined(marketSuspended)) {
        return !marketSuspended;
    }
    if (!isUndefined(marketTradable) && !isUndefined(marketActive)) {
        return marketTradable && marketActive;
    }

    return false;
};

/**
 * @param {Object} event event object
 * @returns {Array<number>} market ids as numbers
 */
export const getDefaultMarkets = (event) => {
    const { grouped_market_ids = [], market_id } = event;

    // using Set will make the market id's unique which is important if this
    // is to be used to register for ws updates.
    return [...new Set([...grouped_market_ids, market_id])].map(Number);
};

/**
 * Replace "Home Team, Away Team, etc..." in market name with real team name
 * @param {String} marketName market name
 * @param {String} homeTeam home team
 * @param {String} awayTeam away team
 * @param {String} sportSlug sport slug
*
 * @returns {String} new market name
 */
export const alterMarketName = (marketName, homeTeam, awayTeam, sportSlug) => {
    if (!marketName || !homeTeam || !awayTeam) {
        return marketName;
    }

    switch(sportSlug) {
        case CRICKET_SLUG:
            return marketName.replace(/team a/i, homeTeam)
                            .replace(/team b/i, awayTeam);
        case DARTS_SLUG:
            return marketName.replace(/\bplayer 1\b/i, homeTeam)
                            .replace(/\bplayer 2\b/i, awayTeam);
        case SNOOKER_SLUG:
            return marketName.replace(/player 1/i, homeTeam)
                            .replace(/player 2/i, awayTeam);
        case BASEBALL_SLUG:
            return marketName.replace(/home team/i, homeTeam)
                            .replace(/away team/i, awayTeam);
        default:
            return marketName.replace(/home team|home/i, homeTeam)
                            .replace(/away team|away/i, awayTeam);
    }
};
